<script setup lang="ts">
const buzzword = ref('kick_ass');
const setBuzzword = (value) => {
    buzzword.value = value;
}
</script>

<template>
    <section class="container space-y-4">
        <p class="code-block">
            hello()<br/>
            let buzzword = "<ClientOnly><CodeInput name="buzzword" :initial-value="buzzword" @update="setBuzzword"/></ClientOnly>"<br/>
        </p>

        <h1 class="max-w-4xl dark:text-white heading-1">
            Building <span class="text-lightula-green dark:text-darkula-green">{{ buzzword }}</span> web app, backend and infrastructure.
        </h1>
        <p class="code-block">
            with the
            <span class="group dark:hover:text-darkula-green hover:text-lightula-green">Igor Vetrov <span
                class="opacity-0 group-hover:opacity-100">🔥</span></span>
        </p>
    </section>
</template>